import { Footer } from 'components/Footer'
import { Header, HeaderType } from 'components/Header'
import { useZoneQuery } from 'hooks/useZoneQuery'
import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import Error from 'next/error'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'
import { ExploreZone } from 'views/explore-zone'

export const ExploreZonePage: NextPage = () => {
  const { query } = useRouter()
  const { formatMessage } = useIntl()

  const { data, loading } = useZoneQuery({ variables: { query: query.zoneSlug } })
  const zone = data?.zone

  if (loading) {
    return null
  }

  if (!zone) {
    return <Error statusCode={404} />
  }

  return (
    <>
      <NextSeo
        title={formatMessage({ id: 'explore.zone.meta.title' }, { zone: zone.name })}
        description={formatMessage({ id: 'explore.zone.meta.description' }, { zone: zone.name })}
      />
      <Header zone={zone} type={HeaderType.Search} />
      <ExploreZone zone={zone} />
      <Footer />
    </>
  )
}

export default ExploreZonePage
